import React, { useState, useEffect, useContext } from "react";
import { Outlet, Link, useLocation } from "react-router-dom";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import { Toaster } from "react-hot-toast";

import DataContext from "../../utils/Context/DataContext";

export default function MainLayout(props) {
  const context = useContext(DataContext);
  const location = useLocation();
  useEffect(() => {
    console.log("AdminLayout onmount context :", context);
  }, []);

  return (
    <>
      <div className="page-body">
        <div className="page-content">
          <Header />
          <Outlet />
        </div>
      </div>
      <Footer />
    </>
  );
}
